import React from 'react';
import ReactDOM from 'react-dom';
import { Routewrapper } from './route/index';
import './styles/index.css';
import './styles/toast-styles.css';
import './styles/responsive.css';
import './services/i18n';
import { Provider } from 'react-redux';
import store from './redux/store';
import { FeatureFlagProvider } from './context/FeatureFlagContext';
import { executeInterceptors } from './services/api.interceptors';

// Interceptors for all requests and responses. Registered before the first render, because
// components send requests as soon as they mount (the sidebar's user-role-order call on a page
// refresh) and a request sent without them has no auth token or Module header.
executeInterceptors();

ReactDOM.render(
  <Provider store={store}>
    <FeatureFlagProvider>
      <Routewrapper />
    </FeatureFlagProvider>
  </Provider>,
  document.getElementById('root')
);
